import React, { Component } from "react";
import PropTypes from "prop-types";
import { Scrollbars as ReactCustomScrollbars } from "react-custom-scrollbars";
import "./Scrollbars.scss";
class Scrollbars extends Component {
  constructor() {
    super();
    this.scrollbarsRef = React.createRef();
  }
  renderTrackVertical = (props) => {
    return <div {...props} className="scrollbar-track track-vertical" data-testid="scroll-trackVertical"/>;
  };
  renderThumbHorizontal = (props) => {
    return <div {...props} className="scrollbar-thumb thumb-horizontal" data-testid="scroll-horizontal"/>;
  };
  renderThumbVertical = (props) => {
    return <div {...props} className="scrollbar-thumb thumb-vertical" data-testid="scroll-vertical"/>;
  };
  render() {
    const { children, className, ...rest } = this.props;
    return (
      <ReactCustomScrollbars
        className={`custom-scrollbar ${className}`}
        ref={this.scrollbarsRef}
        renderTrackVertical={this.renderTrackVertical}
        renderThumbHorizontal={this.renderThumbHorizontal}
        renderThumbVertical={this.renderThumbVertical}
        {...rest}
      >
        {children}
      </ReactCustomScrollbars>
    );
  }
  scrollToBottom = () => {
    setTimeout(() => {
      this.scrollbarsRef.current.scrollToBottom();
    }, 200);
  };
}

Scrollbars.propTypes = {
  className: PropTypes.string,
};

Scrollbars.defaultProps = {
  className: "",
};

export default Scrollbars;
